// import React, { Component } from "react";
// import { FaArrowLeft } from "react-icons/fa6";
// import { FaAngleDown } from "react-icons/fa6";

// class SetExam extends Component {
//     state = {
//         modules: 0,
//         selectedModules: 1,

//         dropdown: false,
//         modulesdropdown: false,
//         selector: "single",


//         question: "",
//         option_no: 0,



//     }



//     handleDropDown = (name) => {
//         this.setState(prevState => ({
//             [name]: !prevState[name]
//         }))
//     }
//     setSelector = (value) => {
//         this.setState({
//             dropdown: false,
//             selector: value
//         })
//     }
//     handleInput = (event) => {
//         const { name, value } = event.target
//         this.setState({
//             [name]: value
//         })
//     }
//     changeModules = (value) => {
//         this.setState({
//             selectedModules: value
//         })
//     }
//     render() {
//         console.log(this.state)
//         const { modules, option_no } = this.state

//         const moduleCount = parseInt(modules, 10) || 0;

//         const modulesList = moduleCount > 0 ? Array.from({ length: moduleCount }, (_, i) => {
//             return (
//                 <li onClick={() => this.changeModules(i + 1)} key={i}>
//                     Module {i + 1}
//                 </li>
//             )
//         }) : null;

//         const optionCount = parseInt(option_no, 10) || 0;
//         const OptionList = optionCount > 0 ? Array.from({ length: optionCount }, (_, i) => {
//             return (
//                 <div className="input half" key={i}><input placeholder="Question Option" name={`option${i + 1}`} value={this.state[`option${i + 1}`]} onChange={this.handleInput}  /></div>
//             )
//         }) : null;


//         return (
//             <div className="dash_exam_container">
//                 <div className="dash_content">
//                     <nav className="navigate">
//                         <button><FaArrowLeft /></button>
//                         <button className="blue">Add Question</button>
//                     </nav>
//                     <div className="modules">
//                         <div className="content">
//                             <label> How many modules </label><br />
//                             <input type="number" name="modules" id="modules" value={this.state.modules || 0} onChange={this.handleInput} placeholder="1"  />
//                         </div>
//                         {this.state.modules > 0 ? <div className="content">
//                             <button onClick={() => this.handleDropDown("modulesdropdown")}>Module {this.state.selectedModules}  <FaAngleDown /></button>
//                             <div className="modulesdrop" style={{ display: this.state.modulesdropdown ? "block" : "none" }}>
//                                 {modulesList}
//                             </div>
//                         </div> : null}
//                     </div>
//                     {this.state.modules > 0 ?
//                         <div className="question_container">
//                             <div className="line">
//                                 <div className="question">
//                                     <label>1</label>
//                                     <input type="text" name="question" id="question" placeholder="Write the question" value={this.state.question} onChange={this.handleInput} />
//                                 </div>
//                                 <div className="selector">
//                                     <div className="select">
//                                         <button onClick={() => this.handleDropDown("dropdown")}> {this.state.selector} <FaAngleDown /></button>
//                                         <div className="dropdown" style={{ display: this.state.dropdown ? "block" : "none" }}>
//                                             <li onClick={() => this.setSelector("single")}>single</li>
//                                             <li onClick={() => this.setSelector("multiple")}>multiple</li>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="container">
//                                 <section className="exam_preview">
//                                     <div className="head">
//                                         <div className="number"><span>1</span></div>
//                                         <div className="writeup">
//                                             <h4>{this.state.question}</h4>
//                                         </div>
//                                     </div>
//                                     <div className="option">
//                                         <input type={this.state.selector === "single" ? "radio" : "checkbox"} />
//                                         <p>{this.state.option1}</p>
//                                     </div>
//                                     <div className="option">
//                                         <input type={this.state.selector === "single" ? "radio" : "checkbox"} />
//                                         <p>{this.state.option2}</p>
//                                     </div>
//                                     <div className="option">
//                                         <input type={this.state.selector === "single" ? "radio" : "checkbox"} />
//                                         <p>{this.state.option3}</p>
//                                     </div>
//                                     <div className="option">
//                                         <input type={this.state.selector === "single" ? "radio" : "checkbox"} />
//                                         <p>{this.state.option4}</p>
//                                     </div>
//                                 </section>
//                                 <section className="exam_info">
//                                     <div className="option_num">
//                                         <div className="cover">
//                                             <label>How many option</label>
//                                             <input type="number" name="option_no" id="option_no" value={this.state.option_no || 0} onChange={this.handleInput} placeholder="1" min={1} />
//                                         </div>
//                                         <div className="cover">
//                                             <label>single name</label>
//                                             <input type="text"  placeholder="The name single" />
//                                         </div>
//                                     </div>
//                                     {this.state.option_no > 0 ? 
//                                     <div className="contain">
//                                         <label>Option Value</label>
//                                         <div className="cover">
//                                             {/* <div className="input half"><input placeholder="Question Option" /></div>
//                                             <div className="input half"><input placeholder="Question Option" /></div> */}
//                                             {OptionList}
//                                         </div>
//                                     </div> : null }
//                                     <div className="contain">
//                                         <label> Question Instruction </label>
//                                         <textarea placeholder="Instruction on the question" />
//                                     </div>
//                                 </section>
//                             </div>
//                         </div> : null}
//                 </div>
//             </div>
//         )
//     }
// }

// export default SetExam













import React, { Component } from "react";
import { FaArrowLeft, FaAngleDown, FaTrash } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";

class SetExam extends Component {
    state = {
        loading: false,
        submitError: "",
        questions: [
            {
                id: 1,
                exam: this.props.exam_id || null,
                text: "",
                selector: "single",
                drop_down_open: false,
                option_no: 2,
                options: [
                    { id: 1, text: "", is_correct: false },
                    { id: 2, text: "", is_correct: false },
                ],
                instruction: "",
                points: "",
            },
        ],
        nextId: 2,
    };

    componentDidMount() {
        this.fetchQuestion();
    }

    addQuestion = () => {
        this.setState((prev) => ({
            questions: [
                ...prev.questions,
                {
                    id: Date.now(),
                    exam: this.props.exam_id,
                    text: "",
                    selector: "single",
                    drop_down_open: false,
                    option_no: 2,
                    options: [
                        { id: 1, text: "", is_correct: false },
                        { id: 2, text: "", is_correct: false },
                    ],
                    instruction: "",
                    points: "",
                },
            ],
            nextId: prev.nextId + 1,
        }));
    };

    deleteQuestion = (qid) => {
        this.setState((prev) => {
            if (prev.questions.length === 1) return prev; // Optional: prevent deleting last question

            const updatedQuestions = prev.questions.filter((q) => q.id !== qid);

            return {
                questions: updatedQuestions,
            };
        });
    };

    toggleDropdown = (qid) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) =>
                q.id === qid ? { ...q, drop_down_open: !q.drop_down_open } : q
            ),
        }));
    };

    setSelector = (qid, value) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) =>
                q.id === qid
                    ? {
                        ...q,
                        selector: value,
                        drop_down_open: false,
                        options:
                            value === "single"
                                ? q.options.map((opt, i) => ({
                                    ...opt,
                                    is_correct: i === 0,
                                }))
                                : q.options.map((opt) => ({
                                    ...opt,
                                    is_correct: false,
                                })),
                    }
                    : q
            ),
        }));
    };

    updatetext = (qid, value) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) =>
                q.id === qid ? { ...q, text: value } : q
            ),
        }));
    };

    updateoption_no = (qid, value) => {
        const num = Math.max(1, parseInt(value) || 1);
        this.setState((prev) => ({
            questions: prev.questions.map((q) => {
                if (q.id !== qid) return q;
                let current = q.options.slice();

                if (num > current.length) {
                    for (let i = current.length; i < num; i++) {
                        current.push({ id: i + 1, text: "", is_correct: false });
                    }
                } else if (num < current.length) {
                    current = current.slice(0, num);
                }

                return {
                    ...q,
                    option_no: num,
                    options: current,
                };
            }),
        }));
    };

    updateOptionValue = (qid, index, value) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) => {
                if (q.id !== qid) return q;
                const options = q.options.map((opt, i) =>
                    i === index ? { ...opt, text: value } : opt
                );
                return { ...q, options };
            }),
        }));
    };

    toggleCorrectOption = (qid, index) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) => {
                if (q.id !== qid) return q;

                let updatedOptions;
                if (q.selector === "single") {
                    updatedOptions = q.options.map((opt, i) => ({
                        ...opt,
                        is_correct: i === index,
                    }));
                } else {
                    updatedOptions = q.options.map((opt, i) =>
                        i === index ? { ...opt, is_correct: !opt.is_correct } : opt
                    );
                }

                return { ...q, options: updatedOptions };
            }),
        }));
    };

    updateInstruction = (qid, value) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) =>
                q.id === qid ? { ...q, instruction: value } : q
            ),
        }));
    };

    updatepoints = (qid, value) => {
        this.setState((prev) => ({
            questions: prev.questions.map((q) =>
                q.id === qid ? { ...q, points: value } : q
            ),
        }));
    };

    fetchQuestion = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const exam_id = this.props.exam_id;

        try {
            const response = await axios.get(
                `https://api.geoinfoacademy.com/api/tutor/exams/${exam_id}/`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const res =
                !response.data.questions || Object.keys(response.data.questions).length < 1
                    ? [
                        {
                            id: 1,
                            text: "",
                            selector: "single",
                            drop_down_open: false,
                            option_no: 2,
                            options: [
                                { id: 1, text: "", is_correct: false },
                                { id: 2, text: "", is_correct: false },
                            ],
                            instruction: "",
                            points: "",
                        },
                    ]
                    : response.data.questions

            this.setState({ questions: res });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handleQuestionSubmit = async () => {
        const accessToken = localStorage.getItem("accessToken");
        this.setState({ loading: true });
        const exam_id = this.props.exam_id;
        const examId = parseInt(exam_id, 10);

        const questionUpdate = {
            questions: this.state.questions,
        };

        const headers = {
            Authorization: `Bearer ${accessToken}`,
        };

        try {
            let response = await axios.patch(
                `https://api.geoinfoacademy.com/api/tutor/exams/${examId}/`,
                questionUpdate,
                { headers }
            );

            this.setState({ loading: false });
            this.fetchQuestion();
            console.log("API response", response);
        } catch (error) {
            console.error("Submit error:", error);
            this.setState({ loading: false, submitError: "Failed to submit. Please try again." });

            // Remove error message after 10 seconds
            setTimeout(() => {
                this.setState({ submitError: null });
            }, 10000); // 10 seconds
        }
    };


    render() {
        const { submitError } = this.state
        return (
            <div className="dash_exam_container">
                <div className="dash_content">
                    <nav className="navigate">
                        <Link to="/tutor_dashboard">
                            <button>
                                <FaArrowLeft />
                            </button>
                        </Link>
                        <button className="blue" onClick={this.addQuestion}>
                            Add Question
                        </button>
                    </nav>
                    <p style={{ fontSize: "14px", fontWeight: "600", color: "red", margin: "20px 0px" }}>{submitError}</p>

                    {this.state.questions.map((q, idx) => (
                        <div className="question_container" key={q.id}>
                            <div className="line">
                                <div className="question">
                                    <label>{idx + 1}</label>
                                    <input
                                        type="text"
                                        placeholder="Write the question"
                                        value={q.text}
                                        onChange={(e) => this.updatetext(q.id, e.target.value)}
                                    />
                                </div>
                                <div
                                    className="selector"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <div className="select">
                                        <button onClick={() => this.toggleDropdown(q.id)}>
                                            {q.selector} <FaAngleDown />
                                        </button>
                                        <div
                                            className="dropdown"
                                            style={{
                                                display: q.drop_down_open ? "block" : "none",
                                            }}
                                        >
                                            <li onClick={() => this.setSelector(q.id, "single")}>
                                                single
                                            </li>
                                            <li onClick={() => this.setSelector(q.id, "multiple")}>
                                                multiple
                                            </li>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => this.deleteQuestion(q.id)}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#e74c3c",
                                            fontSize: "16px",
                                        }}
                                        title="Delete Question"
                                    >
                                        <FaTrash />
                                    </button>
                                </div>
                            </div>

                            <div className="container">
                                <section className="exam_preview">
                                    {q.instruction && <h5>{q.instruction}</h5>}
                                    <div className="head">
                                        <div className="number">
                                            <span>{idx + 1}</span>
                                        </div>
                                        <div className="writeup">
                                            <h4>{q.text.trim() || "What is GIS ?"}</h4>
                                        </div>
                                    </div>
                                    {q.options.map((opt, i) => (
                                        <div className="option" key={opt.id}>
                                            <input
                                                type={
                                                    q.selector === "single" ? "radio" : "checkbox"
                                                }
                                                name={`preview-${q.id}`}
                                                checked={opt.is_correct}
                                                onChange={() =>
                                                    this.toggleCorrectOption(q.id, i)
                                                }
                                            />
                                            <p>{opt.text.trim() || "Question Option"}</p>
                                        </div>
                                    ))}
                                </section>

                                <section className="exam_info">
                                    <div className="option_num">
                                        <div className="cover">
                                            <label>How many options</label>
                                            <input
                                                type="number"
                                                value={q.option_no}
                                                min={1}
                                                onChange={(e) =>
                                                    this.updateoption_no(q.id, e.target.value)
                                                }
                                            />
                                        </div>
                                        <div className="cover">
                                            <label>Question Point</label>
                                            <input
                                                type="number"
                                                placeholder="1"
                                                value={q.points}
                                                onChange={(e) =>
                                                    this.updatepoints(q.id, e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="contain">
                                        <label>Option Value</label>
                                        <div className="cover">
                                            {q.options.map((opt, i) => (
                                                <div
                                                    className="input half"
                                                    key={`opt-input-${q.id}-${i}`}
                                                >
                                                    <input
                                                        placeholder="Question Option"
                                                        value={opt.text}
                                                        onChange={(e) =>
                                                            this.updateOptionValue(
                                                                q.id,
                                                                i,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="contain">
                                        <label> Question Instruction </label>
                                        <textarea
                                            placeholder="Instruction on the question"
                                            value={q.instruction}
                                            onChange={(e) =>
                                                this.updateInstruction(q.id, e.target.value)
                                            }
                                        />
                                    </div>
                                </section>
                            </div>
                        </div>
                    ))}

                    <p style={{ fontSize: "14px", fontWeight: "600", color: "red", margin: "20px 0px" }}>{submitError}</p>

                    <nav className="navigate">
                        <button>Clear</button>
                        <button
                            className="blue"
                            onClick={this.handleQuestionSubmit}
                            disabled={this.state.loading}
                        >
                            {this.state.loading ? "Loading .... " : "Submit"}
                        </button>
                    </nav>
                </div>
            </div>
        );
    }
}

export default SetExam;
